/* CHOWA CART
   A slide-in cart panel (and the /cart page), drawn entirely by this file.
   Every size is written inline on the element that holds it, so no theme
   style can resize anything.

   - The header cart circle opens the panel (except on the /cart page).
   - "Add to cart" adds without leaving the page, then opens the panel
     (window.handleCartSubmit, used by the product page form).
   - The header count is kept in sync.
   - Quantities, removal and the gift note update instantly.
   - Errors (e.g. not enough stock) are shown in the panel, never silent.
   - Empty cart: a calm, designed state with a way back into the shop.

   ACCESSIBILITY, and three things that were wrong.

   ONE -- THE KEYBOARD ONLY WORKED IN THE PANEL. Quantity, Remove and
   the gift note are spans carrying role="button" and tabindex="0",
   which is fine as far as it goes: a span does not respond to Enter or
   Space on its own, so something has to listen. The panel listened.
   The /cart page did not -- it was given a click listener and nothing
   else -- so on the page itself every one of those controls could be
   reached by Tab and then did nothing at all. A control you can focus
   and cannot operate is worse than one you cannot reach, because the
   reader has no way to know it has failed. Both surfaces now share
   onKeyAction. WCAG 2.1: 2.1.1 Keyboard (A).

   TWO -- THE PAGE HAD NO HEADINGS. "Cart" and "Your cart is empty"
   were spans sized to look like headings, so a screen reader user had
   no way to land on either: the whole page was one undifferentiated
   run of text. They are now h1 and h2, styled inline exactly as the
   spans were, with the browser's own margins and weight cleared, so
   nothing looks different. In the panel the same line is a heading
   too, under the dialog's own label. WCAG 2.1: 1.3.1 (A), 2.4.6 (AA).

   THREE -- TWO GREYS FAILED CONTRAST. #8A8A8A is 3.45:1 on white and
   #B5B5B5 is about 2.1:1; AA asks 4.5:1 of text this size, and these
   two carry the variant name, the subtotal label, Remove, the gift
   note label, the shipping line and the price struck through. They are
   now #6E6E6E (5.10:1) and #767676 (4.54:1), which keeps the two tones
   distinct from each other and from the ink. WCAG 2.1: 1.4.3 (AA).

   Every control that acts on one line names that line -- "Remove
   PAULOWNIA BOX SET", not "Remove" -- because in a cart of four things
   four identical "Remove" buttons tell the reader nothing. WCAG 2.1:
   2.4.6 Headings and Labels (AA). */
(function () {
  var BLUE = '#0056A6', INK = '#111111', GREY = '#6E6E6E', SOFT = '#767676';
  var RULE = 'rgba(0,86,166,0.18)', PAPER = '#F3F1ED', ORANGE = '#C4551A';
  var MONO = "'into-mono',monospace";
  var LIGHT = "'Items Text Light','Times New Roman',Times,serif";

  /* clears the browser's own heading margins and weight, so an h1 or
     h2 here looks exactly like the span it replaced */
  var HEAD = 'display:block;margin:0;padding:0;font-weight:normal;letter-spacing:0;text-transform:none;';

  var cart = null, busy = false, isOpen = false, errorMsg = '', noteOpen = false, noteDirty = false;
  var overlay = null, panel = null, pageHost = null, lastFocus = null;

  /* ---------- helpers ---------- */
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function money(cents) {
    var cur = (cart && cart.currency) || 'USD';
    try {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: cur }).format((cents || 0) / 100);
    } catch (e) {
      return '$' + ((cents || 0) / 100).toFixed(2);
    }
  }
  function sized(url, w, h) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w + (h ? '&height=' + h + '&crop=center' : '');
  }
  function root() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }
  function onCartPage() { return /\/cart\/?$/.test(window.location.pathname); }

  function setCount(n) {
    var els = document.querySelectorAll('.cb-cart-count');
    for (var i = 0; i < els.length; i++) els[i].textContent = n;
    try { if (window.siteData && window.siteData.cart) window.siteData.cart.item_count = n; } catch (e) {}
  }

  function api(path, body) {
    var opts = { credentials: 'same-origin', headers: { 'Accept': 'application/json' } };
    if (body) {
      opts.method = 'POST';
      if (body instanceof FormData) {
        opts.body = body;
      } else {
        opts.headers['Content-Type'] = 'application/json';
        opts.body = JSON.stringify(body);
      }
    }
    return fetch(root() + path.replace(/^\//, ''), opts).then(function (r) {
      return r.json().then(function (j) { return { ok: r.ok, json: j }; }, function () { return { ok: r.ok, json: {} }; });
    });
  }

  function load() {
    return api('cart.js').then(function (res) {
      if (res.ok) { cart = res.json; setCount(cart.item_count || 0); }
      draw();
    }).catch(function () { draw(); });
  }

  /* ---------- actions ---------- */
  function changeLine(key, qty) {
    if (busy) return;
    busy = true; errorMsg = ''; draw();
    api('cart/change.js', { id: key, quantity: qty }).then(function (res) {
      busy = false;
      if (res.ok) {
        cart = res.json; setCount(cart.item_count || 0); draw();
      } else {
        errorMsg = (res.json && (res.json.description || res.json.message)) || 'That quantity is not available.';
        load();
      }
    }).catch(function () {
      busy = false; errorMsg = 'Something went wrong. Please try again.'; draw();
    });
  }

  function saveNote(then) {
    var ta = document.getElementById('cc-note');
    if (!ta || !noteDirty) { if (then) then(); return; }
    noteDirty = false;
    api('cart/update.js', { note: ta.value }).then(function (res) {
      if (res.ok) cart = res.json;
      if (then) then();
    }).catch(function () { if (then) then(); });
  }

  /* used by the product page form */
  window.handleCartSubmit = function (form) {
    var btn = form.querySelector('[type="submit"]');
    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    api('cart/add.js', new FormData(form)).then(function (res) {
      if (btn) { btn.disabled = false; btn.textContent = label; }
      if (res.ok) {
        errorMsg = '';
      } else {
        errorMsg = (res.json && (res.json.description || res.json.message)) || 'This item could not be added.';
      }
      return load().then(open);
    }).catch(function () {
      if (btn) { btn.disabled = false; btn.textContent = label; }
      errorMsg = 'Something went wrong. Please try again.';
      load().then(open);
    });
    return false;
  };
  window.openCartModal = function () { load(); open(); return false; };
  window.closeCartModal = function () { close(); };
  window.fetchCartCount = function () { load(); };

  /* ---------- markup ---------- */
  function headerHtml(isPage) {
    var n = cart ? cart.item_count : 0;
    var left = isPage
      ? '<h1 style="' + HEAD + 'font-family:' + LIGHT + ';font-size:32px;line-height:1.1;color:' + INK + ';">Cart</h1>'
      : '<span style="display:inline-flex;align-items:baseline;gap:8px;margin:0;font-family:' + MONO + ';font-size:10px;line-height:1;letter-spacing:0.24em;text-transform:uppercase;color:' + BLUE + ';">Cart<span style="font-family:' + MONO + ';font-size:10px;line-height:1;letter-spacing:0.1em;color:' + GREY + ';">(' + n + ')</span></span>';
    var right = isPage
      ? '<a href="' + root() + 'pages/shop" style="display:inline-flex;align-items:center;margin:0;padding:6px 0;font-family:' + MONO + ';font-size:10px;line-height:1;letter-spacing:0.2em;text-transform:uppercase;color:' + BLUE + ';text-decoration:none;"><span aria-hidden="true" style="display:inline-block;margin-right:8px;font-size:9px;line-height:1;letter-spacing:0;">&larr;</span>Continue shopping</a>'
      : '<span role="button" tabindex="0" data-cc="close" aria-label="Close cart" style="display:inline-flex;align-items:center;margin:0;padding:6px 0;cursor:pointer;font-family:' + MONO + ';font-size:10px;line-height:1;letter-spacing:0.2em;text-transform:uppercase;color:' + BLUE + ';">Close<span aria-hidden="true" style="display:inline-block;margin-left:8px;font-size:14px;line-height:1;letter-spacing:0;">&times;</span></span>';
    return '<div style="display:flex;align-items:center;justify-content:space-between;flex:0 0 auto;box-sizing:border-box;margin:0;padding:' + (isPage ? '0 0 20px' : '20px 24px') + ';border-bottom:0.5px solid ' + RULE + ';font-size:10px;line-height:1;">' + left + right + '</div>';
  }

  function errorHtml() {
    if (!errorMsg) return '';
    return '<div role="alert" style="flex:0 0 auto;margin:0;padding:12px 24px;background:#FBF3EE;border-bottom:0.5px solid rgba(196,85,26,0.25);font-family:' + MONO + ';font-size:10px;line-height:1.6;letter-spacing:0.04em;color:' + ORANGE + ';">' + esc(errorMsg) + '</div>';
  }

  function emptyHtml(isPage) {
    return '<div style="flex:1 1 auto;display:flex;flex-direction:column;align-items:center;justify-content:center;box-sizing:border-box;margin:0;padding:' + (isPage ? '72px 20px' : '48px 32px') + ';text-align:center;font-size:10px;line-height:1;">' +
      '<span style="display:block;margin:0 0 18px;font-family:' + MONO + ';font-size:9px;line-height:1;letter-spacing:0.28em;text-transform:uppercase;color:' + BLUE + ';">Chowa</span>' +
      '<h2 style="' + HEAD + 'margin:0 0 14px;font-family:' + LIGHT + ';font-size:24px;line-height:1.2;color:' + INK + ';">Your cart is empty</h2>' +
      '<span style="display:block;max-width:30ch;margin:0 0 30px;font-family:' + MONO + ';font-size:10px;line-height:1.8;letter-spacing:0.02em;color:' + GREY + ';">Kiri boxes, made by hand in Fukuyama, Japan, for the things you treasure.</span>' +
      '<a href="' + root() + 'pages/shop" style="display:inline-block;margin:0;padding:16px 30px;background:' + BLUE + ';font-family:' + MONO + ';font-size:10px;line-height:1;letter-spacing:0.22em;text-transform:uppercase;color:#ffffff;text-decoration:none;">Browse objects</a>' +
      '<a href="' + root() + 'pages/works" style="display:inline-block;margin:20px 0 0;padding:0 0 4px;border-bottom:0.5px solid rgba(0,86,166,0.45);font-family:' + MONO + ';font-size:9px;line-height:1;letter-spacing:0.2em;text-transform:uppercase;color:' + BLUE + ';text-decoration:none;">See our works</a>' +
    '</div>';
  }

  function lineHtml(item) {
    var name = esc(item.product_title);
    var variant = item.variant_title && item.variant_title !== 'Default Title' ? esc(item.variant_title) : '';
    var disc = item.original_line_price > item.final_line_price;
    var btn = 'display:flex;align-items:center;justify-content:center;width:32px;height:32px;margin:0;padding:0;cursor:pointer;-webkit-tap-highlight-color:transparent;user-select:none;-webkit-user-select:none;font-family:' + MONO + ';font-size:13px;line-height:1;color:' + INK + ';';
    var imgUrl = item.featured_image && item.featured_image.url ? item.featured_image.url : item.image;
    return '<div style="display:grid;grid-template-columns:76px minmax(0,1fr);gap:16px;margin:0;padding:20px 0;border-bottom:0.5px solid ' + RULE + ';font-size:10px;line-height:1;">' +
      '<a href="' + esc(item.url) + '" tabindex="-1" aria-hidden="true" style="display:block;width:76px;height:95px;overflow:hidden;background:' + PAPER + ';font-size:0;line-height:0;">' +
        (imgUrl ? '<img src="' + esc(sized(imgUrl, 240, 300)) + '" alt="" loading="lazy" style="display:block;width:100%;height:100%;max-width:none;object-fit:cover;">' : '') +
      '</a>' +
      '<div style="display:flex;flex-direction:column;min-width:0;margin:0;padding:0;">' +
        '<div style="display:flex;align-items:flex-start;justify-content:space-between;gap:14px;margin:0;">' +
          '<a href="' + esc(item.url) + '" style="display:block;min-width:0;margin:0;font-family:' + LIGHT + ';font-size:16px;line-height:1.25;color:' + INK + ';text-decoration:none;">' + name + '</a>' +
          '<span style="display:block;flex:0 0 auto;margin:2px 0 0;text-align:right;font-family:' + MONO + ';font-size:11px;line-height:1.4;letter-spacing:0.04em;color:' + INK + ';white-space:nowrap;">' +
            (disc ? '<span style="display:block;font-family:' + MONO + ';font-size:10px;line-height:1.4;color:' + SOFT + ';text-decoration:line-through;"><span class="cc-sr" style="position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap;">Was </span>' + money(item.original_line_price) + '</span>' : '') +
            money(item.final_line_price) +
          '</span>' +
        '</div>' +
        (variant ? '<span style="display:block;margin:6px 0 0;font-family:' + MONO + ';font-size:9px;line-height:1.4;letter-spacing:0.16em;text-transform:uppercase;color:' + GREY + ';">' + variant + '</span>' : '') +
        (item.quantity > 1 ? '<span style="display:block;margin:4px 0 0;font-family:' + MONO + ';font-size:9px;line-height:1.4;letter-spacing:0.06em;color:' + SOFT + ';">' + money(item.final_price) + ' each</span>' : '') +
        '<div style="display:flex;align-items:center;justify-content:space-between;margin:auto 0 0;padding:14px 0 0;">' +
          '<div style="display:inline-flex;align-items:center;margin:0;border:0.5px solid rgba(17,17,17,0.3);">' +
            '<span role="button" tabindex="0" aria-label="Decrease quantity of ' + name + '" data-cc="qty" data-key="' + esc(item.key) + '" data-q="' + (item.quantity - 1) + '" style="' + btn + '">&minus;</span>' +
            '<span aria-live="polite" aria-label="Quantity of ' + name + ': ' + item.quantity + '" style="display:flex;align-items:center;justify-content:center;min-width:26px;height:32px;margin:0;font-family:' + MONO + ';font-size:11px;line-height:1;color:' + INK + ';">' + item.quantity + '</span>' +
            '<span role="button" tabindex="0" aria-label="Increase quantity of ' + name + '" data-cc="qty" data-key="' + esc(item.key) + '" data-q="' + (item.quantity + 1) + '" style="' + btn + '">+</span>' +
          '</div>' +
          '<span role="button" tabindex="0" aria-label="Remove ' + name + ' from cart" data-cc="qty" data-key="' + esc(item.key) + '" data-q="0" style="display:inline-block;margin:0;padding:0 0 3px;cursor:pointer;border-bottom:0.5px solid rgba(110,110,110,0.6);font-family:' + MONO + ';font-size:9px;line-height:1;letter-spacing:0.18em;text-transform:uppercase;color:' + GREY + ';">Remove</span>' +
        '</div>' +
      '</div>' +
    '</div>';
  }

  function footerHtml(isPage) {
    var note = (cart && cart.note) || '';
    var noteBlock = noteOpen || note
      ? '<label for="cc-note" style="display:block;margin:0 0 8px;font-family:' + MONO + ';font-size:9px;line-height:1;letter-spacing:0.2em;text-transform:uppercase;color:' + GREY + ';">Gift note</label>' +
        '<textarea id="cc-note" rows="3" placeholder="A few words for the recipient" style="display:block;width:100%;box-sizing:border-box;margin:0 0 18px;padding:10px 12px;border:0.5px solid rgba(17,17,17,0.3);border-radius:0;background:#ffffff;resize:vertical;font-family:' + MONO + ';font-size:16px;line-height:1.5;color:' + INK + ';">' + esc(note) + '</textarea>'
      : '<span role="button" tabindex="0" data-cc="note" style="display:inline-block;margin:0 0 18px;padding:0 0 3px;cursor:pointer;border-bottom:0.5px solid rgba(0,86,166,0.45);font-family:' + MONO + ';font-size:9px;line-height:1;letter-spacing:0.2em;text-transform:uppercase;color:' + BLUE + ';">+ Add a gift note</span>';
    var discount = cart && cart.total_discount > 0
      ? '<div style="display:flex;justify-content:space-between;align-items:baseline;margin:0 0 8px;"><span style="font-family:' + MONO + ';font-size:10px;line-height:1;letter-spacing:0.2em;text-transform:uppercase;color:' + GREY + ';">Savings</span><span style="font-family:' + MONO + ';font-size:12px;line-height:1;color:' + INK + ';">&minus;' + money(cart.total_discount) + '</span></div>'
      : '';
    return '<div style="flex:0 0 auto;box-sizing:border-box;margin:0;padding:' + (isPage ? '28px 0 0' : '18px 24px calc(20px + env(safe-area-inset-bottom, 0px))') + ';border-top:0.5px solid ' + RULE + ';background:#ffffff;font-size:10px;line-height:1;">' +
      noteBlock + discount +
      '<div style="display:flex;justify-content:space-between;align-items:baseline;margin:0 0 8px;">' +
        '<span style="font-family:' + MONO + ';font-size:10px;line-height:1;letter-spacing:0.2em;text-transform:uppercase;color:' + GREY + ';">Subtotal</span>' +
        '<span style="font-family:' + MONO + ';font-size:14px;line-height:1;letter-spacing:0.04em;color:' + INK + ';">' + money(cart.total_price) + '</span>' +
      '</div>' +
      '<span style="display:block;margin:0 0 18px;font-family:' + MONO + ';font-size:9px;line-height:1.5;letter-spacing:0.04em;color:' + GREY + ';">Shipping and taxes calculated at checkout.</span>' +
      '<a href="' + root() + 'checkout" data-cc="checkout" style="display:block;width:100%;box-sizing:border-box;margin:0;padding:18px 16px;background:' + BLUE + ';text-align:center;font-family:' + MONO + ';font-size:10px;line-height:1;letter-spacing:0.22em;text-transform:uppercase;color:#ffffff;text-decoration:none;">Checkout &middot; ' + money(cart.total_price) + '</a>' +
      '<span style="display:block;margin:12px 0 0;text-align:center;font-family:' + MONO + ';font-size:9px;line-height:1.5;letter-spacing:0.12em;text-transform:uppercase;color:' + SOFT + ';">Secure checkout &middot; Handcrafted in Japan</span>' +
    '</div>';
  }

  function contentHtml(isPage) {
    var has = cart && cart.item_count > 0;
    var body = has
      ? '<div class="cc-lines" style="flex:1 1 auto;box-sizing:border-box;margin:0;padding:0 ' + (isPage ? '0' : '24px') + ';overflow-y:' + (isPage ? 'visible' : 'auto') + ';-webkit-overflow-scrolling:touch;overscroll-behavior:contain;opacity:' + (busy ? '0.5' : '1') + ';pointer-events:' + (busy ? 'none' : 'auto') + ';transition:opacity 0.15s;">' +
          cart.items.map(lineHtml).join('') +
        '</div>' + footerHtml(isPage)
      : emptyHtml(isPage);
    return headerHtml(isPage) + errorHtml() + body;
  }

  function draw() {
    if (panel) panel.innerHTML = contentHtml(false);
    if (pageHost) pageHost.innerHTML = '<div style="display:flex;flex-direction:column;margin:0;padding:0;">' + contentHtml(true) + '</div>';
  }

  /* ---------- panel ---------- */
  function build() {
    if (panel) return;
    overlay = document.createElement('div');
    overlay.setAttribute('data-cc', 'close');
    overlay.style.cssText = 'position:fixed;top:0;left:0;right:0;bottom:0;z-index:2147480000;background:rgba(17,17,17,0.28);opacity:0;visibility:hidden;transition:opacity 0.3s ease,visibility 0.3s;';
    panel = document.createElement('aside');
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-modal', 'true');
    panel.setAttribute('aria-label', 'Cart');
    panel.style.cssText = 'position:fixed;top:0;right:0;bottom:0;z-index:2147480001;display:flex;flex-direction:column;box-sizing:border-box;width:420px;max-width:100vw;height:100%;margin:0;padding:0;background:#ffffff;box-shadow:-12px 0 40px rgba(0,0,0,0.08);transform:translateX(100%);visibility:hidden;transition:transform 0.34s cubic-bezier(0.22,0.61,0.36,1),visibility 0.34s;font-size:10px;line-height:1;';
    document.body.appendChild(overlay);
    document.body.appendChild(panel);
    panel.addEventListener('click', onAction);
    panel.addEventListener('keydown', onKeyAction);
    panel.addEventListener('input', function (e) { if (e.target && e.target.id === 'cc-note') noteDirty = true; });
    panel.addEventListener('change', function (e) { if (e.target && e.target.id === 'cc-note') saveNote(); });
    overlay.addEventListener('click', close);
  }

  function open() {
    if (onCartPage()) return;
    build();
    draw();
    isOpen = true;
    lastFocus = document.activeElement;
    overlay.style.visibility = 'visible';
    overlay.style.opacity = '1';
    panel.style.visibility = 'visible';
    panel.style.transform = 'translateX(0)';
    document.documentElement.style.overflow = 'hidden';
    setTimeout(function () {
      var c = panel.querySelector('[data-cc="close"]');
      if (c && c.focus) c.focus();
    }, 50);
  }
  function close() {
    if (!panel || !isOpen) return;
    saveNote();
    isOpen = false;
    overlay.style.opacity = '0';
    overlay.style.visibility = 'hidden';
    panel.style.transform = 'translateX(100%)';
    panel.style.visibility = 'hidden';
    document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
  }

  function onAction(e) {
    var t = e.target && e.target.closest ? e.target.closest('[data-cc]') : null;
    if (!t) return;
    var act = t.getAttribute('data-cc');
    if (act === 'close') { e.preventDefault(); close(); }
    else if (act === 'qty') { e.preventDefault(); changeLine(t.getAttribute('data-key'), parseInt(t.getAttribute('data-q'), 10) || 0); }
    else if (act === 'note') {
      e.preventDefault(); noteOpen = true; draw();
      var ta = document.getElementById('cc-note'); if (ta) ta.focus();
    }
    else if (act === 'checkout') {
      if (noteDirty) {
        e.preventDefault();
        var href = t.getAttribute('href');
        saveNote(function () { window.location.href = href; });
      }
    }
  }

  /* Enter and Space on the role="button" spans. Shared by the panel and
     the /cart page -- the page used to have no key handler at all, so
     every one of those controls was focusable and dead. */
  function onKeyAction(e) {
    if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
    var t = e.target && e.target.closest ? e.target.closest('[data-cc]') : null;
    if (!t) return;
    if (t.tagName === 'A' || t.tagName === 'TEXTAREA' || t.tagName === 'BUTTON') return;
    e.preventDefault();
    onAction({ target: t, preventDefault: function () {} });
  }

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && isOpen) close(); });

  /* header cart circle opens the panel (the /cart page stays a page) */
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a.cb-cart') : null;
    if (!a || onCartPage()) return;
    e.preventDefault();
    load();
    open();
  }, true);

  /* the /cart page */
  function start() {
    pageHost = document.getElementById('chowa-cart-page');
    if (pageHost) {
      pageHost.addEventListener('click', onAction);
      pageHost.addEventListener('keydown', onKeyAction);
      pageHost.addEventListener('input', function (e) { if (e.target && e.target.id === 'cc-note') noteDirty = true; });
      pageHost.addEventListener('change', function (e) { if (e.target && e.target.id === 'cc-note') saveNote(); });
    }
    load();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
